import React, { useState } from 'react';
import { Search, Menu, X, ShoppingCart, ChevronDown, Check, Bell, User } from 'lucide-react';
import { navItems } from './NavLinksData';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { CartButton } from '../../../../ui/elements/CartButton';
import { useEffect, useRef } from 'react';
import PublicProfileMenu from './PublicProfileMenu';


const MobileNav: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);
  const navigate = useNavigate();
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const searchRef = useRef<HTMLDivElement>(null);

  // Fermer le popup si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setShowSearch(false);
        setSearchTerm('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const toggleDropdown = (name: string) => {
    setOpenDropdown(openDropdown === name ? null : name);
  };

  return (

    <>
      <div className="flex md:hidden items-center gap-2 md:gap-3">
       
        

        {/* Menu utilisateur externalisé */}
        <PublicProfileMenu />


      </div>

    </>

  );
};

export default MobileNav;